"use client";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokMediaWithCaption } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import { AssetBlok, sizes } from "../Asset";
import { MediaLink } from "../MediaLink";
import styles from "./MediaWithCaption.module.css";

export const MediaWithCaptionBlok = ({
	blok,
	preview,
	className,
}: BlokProps<BlokMediaWithCaption> & {
	className?: string;
}) => {
	const classNames: Array<string | undefined> = [styles.root, className];

	if (blok.displayMode === "text_inside") {
		classNames.push(styles.textInside);
	}

	return (
		<BlokWrap editable={blok} asChild className={clsx(...classNames)}>
			<figure>
				<div className={styles.mediaContainer}>
					{!!blok.media?.length && (
						<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
							<AssetBlok muted autoPlay loop source={blok.media} sizes={sizes(50)} />
						</MediaLink>
					)}
				</div>
				{blok.caption && <figcaption className={styles.caption}>{blok.caption}</figcaption>}
			</figure>
		</BlokWrap>
	);
};
